import { Component, OnInit } from '@angular/core';
import { TitularesService } from 'app/services/titulares.service';
import { BeneficiariosService } from 'app/services/beneficiarios.service';
import { PrioridadesService } from 'app/services/prioridades.service';

@Component({
  selector: 'app-consultar-contrato',
  templateUrl: './consultar-contrato.component.html',
  styleUrls: ['./consultar-contrato.component.scss']
})
export class ConsultarContratoComponent implements OnInit {

  dataSource:any;
  displayedColumns: string[] = [
    'prioridad',
    'promedioServicio',
    'total_servicios',
    'beneficiarios',
    'psm',
    'servicio_adecuado',
    'titnit',
    'grunom',
    'pec',
    'grugru',
    'PerTiempoTit',
    'cobini',
    'TC',
  ];

  grugru:number;

  historico:boolean = true;

  //SAT
  satTotal:number;

  rangosPrioridad;

  constructor(
    private titService:TitularesService, 
    private benService:BeneficiariosService,
    private prioridades:PrioridadesService
  ) { }

  ngOnInit() {
    this.prioridades.prioridades().then(data=>{
      this.rangosPrioridad = data;
      console.log(this.rangosPrioridad);
    });
  }

  buscarPorRadicado() {
    this.titService.totalServiciosContrato(this.grugru, this.historico).subscribe(data=>{
      console.log(data);
      this.dataSource = data;

      //Por cada titular consultado
      for (let i = 0; i < this.dataSource.length; i++) {
        console.log("titular consultado");
        const contrato = this.dataSource[i];
        //Consultar la lista de sus beneficiarios
        this.consultarBeneficiarios(i, contrato.ID_Grupo);
      }

      if (parseInt(this.dataSource.benMayores) == 0 && parseInt(this.dataSource.benMenores) == 0 && parseInt(this.dataSource.benIntermedio) == 0) {
        this.dataSource.equilibrado = "Cancelado";
      } else {
        if (parseInt(this.dataSource.benMayores) + parseInt(this.dataSource.benMenores) > parseInt(this.dataSource.benIntermedio)) {
          this.dataSource.equilibrado = "Descompensado";
        } else {
          this.dataSource.equilibrado = "Compensado";
        }
      }

      //this.satTotal = 0;
    });
  }

  dateFormat(fecha) {
    return new Date(fecha).toLocaleDateString();
  }

  beneficiarios:any;
  meses:any;
  consultarBeneficiarios(index, id_grupo) {
    //Consultamos los beneficiarios que tiene un contrato
    this.titService.beneficiariosContrato(id_grupo).subscribe(async beneficiarios=>{

      this.beneficiarios = beneficiarios;
      let sat = 0;
      console.log("sat", sat);

      //Recorremos el array de todos los beneficiarios
      for (let i = 0; i < this.beneficiarios.length; i++) {
        const beneficiario = beneficiarios[i];

        //Obtenemos los meses que ha estado cada uno
        await this.benService.totalMeses(beneficiario.id_ben).then(meses=>{
          this.meses = meses;
          //SAT
          sat += (0.25 * this.meses);
          console.log("Consultó el sat:", sat);
        });

      }

      let ps;
      if (sat == 0) {
        ps = 0;
      } else {
        ps = (this.dataSource[index].servicios_contrato / sat);
      }

      let prioridad;

      //Si tiene estado ApoyoVip 1 en la base de datos tendrá prioridad VIP
      if (this.dataSource[index].ID_Titular.ApoyoVip == 1) {
        prioridad = "VIP";
      } else if (this.dataSource[index].ID_Titular == 7477) {
        //La asociación viva cerritos se toma como prioridad APE
        prioridad = "APE";
      } else if (this.dataSource[index].bencba == 15) {
        //Las cortesías tienen prioridad COR
        prioridad = "COR";
      } else {
        //Si el beneficiario solo tiene un servicio y lleva menos de 6 meses
        //Siempre será prioridad 2
        if (this.dataSource[index].total_servicios == "1" && this.dataSource[index].meses <= 6) {
          prioridad = "2";
        } else {
          //Dependiendo el promedio del contrato
          //se determina la prioridad del servicio
          if (ps < this.rangosPrioridad[0].rango_final) {
            prioridad = this.rangosPrioridad[0].prioridad;
          } else if(ps < this.rangosPrioridad[1].rango_final) {
            prioridad = this.rangosPrioridad[1].prioridad;
          } else if(ps < this.rangosPrioridad[2].rango_final) {
            prioridad = this.rangosPrioridad[2].prioridad;
          } else if(ps < this.rangosPrioridad[3].rango_final) {
            prioridad = this.rangosPrioridad[3].prioridad;
          } else if(ps < this.rangosPrioridad[4].rango_final) {
            prioridad = this.rangosPrioridad[4].prioridad;
          } else {
            prioridad = "5";
          }
        }
      }
      this.dataSource[index].prioridad = prioridad;

      //tomar solo las iniciales del tipo contrato
      let matches = this.dataSource[index].tpcnom.match(/\b(\w)/g); // ['J','S','O','N']
      let acronym = matches.join('');
      this.dataSource[index].tc = acronym;

      this.dataSource[index].promedioServicio = ps.toFixed(2);
      this.dataSource[index].servicio_adecuado = sat.toFixed(2);
      console.log("Consultó los beneficiarios");
    });
  }

}
